import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { ESendStatus } from "components/IconsState/typings";
import { Tooltip } from "@mui/material";
import { EEvidenceEvent } from "dto/EEvidenceEvent";
import { evidenceEventToStatus } from "utils/evidenceEventToStatus";
import { useTranslation } from "react-i18next";

const SendStatusBadge: FC<Props> = ({
  status,
  edeliveryEvent,
}) => {
  const { t } = useTranslation();
  const getColor = () => {
    if (edeliveryEvent) {
      switch (edeliveryEvent) {
        case EEvidenceEvent.SubmissionAcceptance:
        case EEvidenceEvent.RelayAcceptance:
          return "#fa6b2f";

        case EEvidenceEvent.SubmissionRejection:
        case EEvidenceEvent.RelayRejection:
        case EEvidenceEvent.RelayFailure:
        case EEvidenceEvent.ConsignmentRejection:
        case EEvidenceEvent.AcceptanceRejectionExpiry:
        case EEvidenceEvent.RelayToNonERDS:
        case EEvidenceEvent.RelayToNonERDSFailure:
        case EEvidenceEvent.ReceivedFromNonERDS:
        case EEvidenceEvent.ContentHandoverFailure:
        case EEvidenceEvent.ContentConsignmentFailure:
        case EEvidenceEvent.NotificationForAcceptanceFailure:
        case EEvidenceEvent.ConsignmentNotificationFailure:
          return "#b9121b";

        case EEvidenceEvent.NotificationForAcceptance:
        case EEvidenceEvent.ConsignmentNotification:
        case EEvidenceEvent.ConsignmentAcceptance:
        case EEvidenceEvent.ContentConsignment:
          return "#9cd326";

        case EEvidenceEvent.ContentHandover:
          return "#2a8429";
      }

      return "#D58C00";
    }

    switch (status) {
      case ESendStatus.ERROR:
      case ESendStatus.ERROR_NOT_RETRAYABLE:
        return "#b9121b";
      case ESendStatus.PROCESSING:
      case ESendStatus.WAITING:
        return "#b3891c";
      case ESendStatus.SENT:
        return "#fa6b2f";
    }
  };

  const getClassName = () => {
    if (edeliveryEvent !== null) {
      switch (edeliveryEvent) {
        case EEvidenceEvent.SubmissionAcceptance:
        case EEvidenceEvent.RelayAcceptance:
          return styles.waiting;

        case EEvidenceEvent.SubmissionRejection:
        case EEvidenceEvent.RelayRejection:
        case EEvidenceEvent.RelayFailure:
        case EEvidenceEvent.ConsignmentRejection:
        case EEvidenceEvent.AcceptanceRejectionExpiry:
        case EEvidenceEvent.RelayToNonERDS:
        case EEvidenceEvent.RelayToNonERDSFailure:
        case EEvidenceEvent.ReceivedFromNonERDS:
        case EEvidenceEvent.ContentHandoverFailure:
        case EEvidenceEvent.ContentConsignmentFailure:
        case EEvidenceEvent.NotificationForAcceptanceFailure:
        case EEvidenceEvent.ConsignmentNotificationFailure:
          return styles.error;

        case EEvidenceEvent.NotificationForAcceptance:
        case EEvidenceEvent.ConsignmentNotification:
        case EEvidenceEvent.ConsignmentAcceptance:
        case EEvidenceEvent.ContentConsignment:
          return styles.waiting2;

        case EEvidenceEvent.ContentHandover:
          return styles.success2;
      }

      return styles.waiting;
    }

    switch (status) {
      case ESendStatus.ERROR:
      case ESendStatus.ERROR_NOT_RETRAYABLE:
        return styles.error;
      case ESendStatus.PROCESSING:
      case ESendStatus.WAITING:
      case ESendStatus.SENT:
        return styles.success;
    }
  };

  const getName = () => {
    if (edeliveryEvent !== null) {
      return evidenceEventToStatus(edeliveryEvent, false);
    }

    switch (status) {
      case ESendStatus.ERROR_NOT_RETRAYABLE:
        return t("errors.error");
      case ESendStatus.WAITING:
        return t("statuses.waiting");
      case ESendStatus.PROCESSING:
      case ESendStatus.ERROR:
        return t("statuses.inProgress");
      case ESendStatus.SENT:
        return t("statuses.sentShort");
    }
  };

  return (
    <div className={`${styles.chip} ${getClassName()}`}>
      <div className={styles.icon}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_54775_65726"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <rect width="20" height="20" fill="white" />
          </mask>
          <g mask="url(#mask0_54775_65726)">
            <path
              d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5Z"
              fill={getColor()}
            />
          </g>
        </svg>
      </div>
      <Tooltip title={getName()}>
        <div className={styles.name}>{getName()}</div>
      </Tooltip>
    </div>
  );
};

export default SendStatusBadge;
